<template>
  <div class="container-fluid">
    <splitpanes
      class="default-theme"
      :style="{ height: splitPaneHeight }"
      :size="10"
    >
      <pane max-size="45">
        <div class="row" style="margin: 5px">
          <div class="col" style="text-align: center">
            <b-button-group>
              <b-button
                style="font-size: 12px"
                variant="success"
                @click="selectedPeriodTimesToday"
                >{{ this.$store.state.localization.data.common.periodTimesOptions.today }}</b-button
              >
              <b-button
                style="font-size: 12px"
                variant="success"
                @click="selectedPeriodTimesYesterday"
                >{{ this.$store.state.localization.data.common.periodTimesOptions.yesterday }}</b-button
              >
              <b-button
                style="font-size: 12px"
                variant="success"
                @click="selectedPeriodTimesLastWeek"
                >{{ this.$store.state.localization.data.common.periodTimesOptions.lastWeek }}</b-button
              >
              <b-button
                style="font-size: 12px"
                variant="success"
                @click="selectedPeriodTimesLastMonth"
                >{{ this.$store.state.localization.data.common.periodTimesOptions.lastMonth }}</b-button
              >
            </b-button-group>
          </div>
        </div>

        <div class="row">
          <div
            class="col-4 align-self-center"
            style="margin-left: 5px; margin-bottom: 5px; font-size: 12px"
          >
            <label>{{ this.$store.state.localization.data.common.beginPeriodLabel }}:</label>
          </div>
          <div class="col-3" style="margin-left: -30px; margin-bottom: 5px">
            <input
              type="date"
              style="font-size: 12px; width: 120px"
              v-model="beginDate"
            />
          </div>
          <div class="col-2" style="margin-left: 10px">
            <input type="time" style="font-size: 12px" v-model="beginTime" />
          </div>
        </div>

        <div class="row">
          <div
            class="col-4 align-self-center"
            style="margin-left: 5px; margin-bottom: 5px; font-size: 12px"
          >
            <label>{{ this.$store.state.localization.data.common.endPeriodLabel }}:</label>
          </div>
          <div class="col-3" style="margin-left: -30px; margin-bottom: 5px">
            <input
              type="date"
              style="font-size: 12px; width: 120px"
              v-model="endDate"
            />
          </div>
          <div class="col-2" style="margin-left: 10px">
            <input type="time" style="font-size: 12px" v-model="endTime" />
          </div>
        </div>

        <div class="row">
          <div
            class="col-4 align-self-center"
            style="margin-left: 5px; margin-bottom: 5px; font-size: 12px"
          >
            <label
              >{{
                this.$store.state.localization.data.mainPage.reports
                  .selectReportLabel
              }}:</label
            >
          </div>
          <div class="col-3" style="margin-left: -30px; margin-bottom: 5px">
            <b-form-select
              v-model="reportNames.selected"
              :options="reportNames.options"
              @change="selectReport($event)"
              style="font-size: 12px; width: 200px"
              :state="isReportNameValid"
            ></b-form-select>
          </div>
          <div class="col-3" style="margin-left: 80px; margin-bottom: 5px">
            <b-button-group>
              <b-button
                style="font-size: 12px; width: 40px"
                variant="success"
                :disabled="createReportActiveLabel"
                :title="$store.state.localization.data.mainPage.reports.addSettingLabel"
                @click="createReport"
              >
                <b-icon icon="plus"></b-icon>
              </b-button>
              <b-button
                style="font-size: 12px; width: 40px"
                variant="success"
                :disabled="!isSelectedReport || !isSelectedUserReport"
                :title="$store.state.localization.data.mainPage.reports.changeSettingLabel"
                @click="updateReport"
              >
                <b-icon icon="arrow-repeat"></b-icon>
              </b-button>
              <b-button
                style="font-size: 12px; width: 40px"
                variant="success"
                :disabled="!isSelectedReport || !isSelectedUserReport"
                :title="$store.state.localization.data.mainPage.reports.deleteSettingLabel"
                @click="deleteReport"
              >
                <b-icon icon="x"></b-icon>
              </b-button>
            </b-button-group>
          </div>
        </div>

        <div class="row">
          <div
            class="col-4 align-self-center"
            style="margin-left: 5px; margin-bottom: 5px"
          >
            <label style="font-size: 12px"
              >{{
                this.$store.state.localization.data.mainPage.reports
                  .selectPeriodTypeLabel
              }}:</label
            >
          </div>
          <div class="col-3" style="margin-left: -30px; margin-bottom: 5px">
            <b-form-select
              v-model="report.periodTypes.selected"
              :options="report.periodTypes.options"
              style="font-size: 12px; width: 200px"
            ></b-form-select>
          </div>
        </div>

        <div class="row">
          <div
            class="col-4 align-self-center"
            style="margin-left: 5px; margin-bottom: 5px"
          >
            <label style="font-size: 12px"
              >{{
                this.$store.state.localization.data.mainPage.reports
                  .selectGroupLabel
              }}:</label
            >
          </div>
          <div class="col-3" style="margin-left: -30px; margin-bottom: 5px">
            <b-form-select
              v-model="report.groups.selected"
              :options="report.groups.options"
              style="font-size: 12px; width: 200px"
            ></b-form-select>
          </div>
        </div>

        <div class="row">
          <div
            class="col-4 align-self-center"
            style="margin-left: 5px; margin-bottom: 5px"
          >
            <label style="font-size: 12px"
              >{{
                this.$store.state.localization.data.mainPage.reports
                  .selectFilterLabel
              }}:</label
            >
          </div>
          <div class="col-3" style="margin-left: -30px; margin-bottom: 5px">
            <b-form-select
              v-model="report.filterKeys.selected"
              :options="report.filterKeys.options"
              @change="selectReportFilter($event)"
              style="font-size: 12px; width: 200px"
              :state="isReportFilterKeysValid"
            ></b-form-select>
          </div>
        </div>

        <div class="row">
          <div
            class="col-4 align-self-center"
            style="margin-left: 5px; margin-bottom: 5px"
          >
            <label style="font-size: 12px"
              >{{
                this.$store.state.localization.data.mainPage.reports
                  .selectFilterValueLabel
              }}:</label
            >
          </div>
          <div class="col-3" style="margin-left: -30px; margin-bottom: 5px">
            <vue-multi-select
              id="report_filter_keys"
              v-model="report.filterValues.values"
              :filters="report.filterValues.filters"
              :options="report.filterValues.options"
              :selectOptions="report.filterValues.data"
              :btnLabel="report.filterValues.btnLabel"
              :state="isReportFilterValuesValid"
              search
              v-bind:searchPlaceholder="$store.state.localization.data.mainPage.reports.searchLabel"
            />
          </div>
        </div>

        <div class="row">
          <div
            class="col"
            style="margin-left: 5px; margin-bottom: 5px; text-align: center"
          >
            <label style="font-size: 12px"
              >{{
                this.$store.state.localization.data.mainPage.reports
                  .selectColumnLabel
              }}:</label
            >
          </div>
        </div>

        <div
          class="row no-gutters"
          style="margin-left: 5px; margin-bottom: 5px"
        >
          <div class="col-5">
            <b-form-select
              v-model="report.columnsLeft.data"
              :options="report.columnsLeft.values"
              multiple
              :select-size="12"
              style="font-size: 12px"
              @dblclick="selectColumns"
              ref="columnsLeftRef"
            ></b-form-select>
          </div>
          <div class="col-1 align-self-center" style="text-align: center">
            <b-button-group vertical>
              <b-button
                size="sm"
                style="font-size: 12px"
                variant="success"
                @click="selectColumns"
                >&#62;</b-button
              >
              <b-button
                size="sm"
                style="font-size: 12px"
                variant="success"
                @click="selectAllColumns"
                >&#62;&#62;</b-button
              >
              <b-button
                size="sm"
                style="font-size: 12px"
                variant="success"
                @click="deselectAllColumns"
                >&#60;&#60;</b-button
              >
              <b-button
                size="sm"
                style="font-size: 12px"
                variant="success"
                @click="deselectColumns"
                >&#60;</b-button
              >
            </b-button-group>
          </div>
          <div class="col-5">
            <b-form-select
              v-model="report.columnsRight.data"
              :options="report.columnsRight.values"
              multiple
              :select-size="12"
              style="font-size: 12px"
              ref="columnsRightRef"
              :state="isReportColumnsRightValid"
            ></b-form-select>
          </div>
          <div class="col-1 align-self-center" style="text-align: center">
            <b-button-group vertical>
              <b-button
                size="sm"
                style="font-size: 12px; width: 32px"
                variant="success"
                @click="upColumns"
                >+</b-button
              >
              <b-button
                size="sm"
                style="font-size: 12px"
                variant="success"
                @click="downColumns"
                >-</b-button
              >
            </b-button-group>
          </div>
        </div>

        <div class="row" style="margin-left: 5px; margin-bottom: 5px">
          <div class="col-6">
            <b-button
              style="font-size: 12px; margin-left: -15px; width: 190px"
              variant="success"
              class="btn-block"
              @click="getReport"
              v-b-tooltip.hover title="Tooltip directive content"
              >{{ this.$store.state.localization.data.mainPage.reports.buildReportButton }}</b-button
            >
          </div>
          <div class="col-6">
            <b-button-group
              v-if="
                $store.state.authentication.roles.indexOf(
                  REPORTS_EXPORT_ROLE
                ) != -1
              "
            >
              <b-button
                style="font-size: 12px; margin-left: -20px"
                variant="success"
                @click="exportReport('xlsx')"
                :disabled="report.data == null"
                :title="$store.state.localization.data.mainPage.reports.exportXlsxReportButton"
                >.XLSX</b-button
              >
              <b-button
                style="font-size: 12px"
                variant="success"
                @click="exportReport('pdf')"
                :disabled="report.data == null"
                :title="$store.state.localization.data.mainPage.reports.exportWordReportButton"
                >.PDF</b-button
              >
              <b-button
                style="font-size: 12px"
                variant="success"
                @click="exportReport('xml')"
                :disabled="report.data == null"
                :title="$store.state.localization.data.mainPage.reports.exportXmlReportButton"
                >.XML</b-button
              >
            </b-button-group>
          </div>
        </div>
      </pane>

      <pane>
        <!-- <div class="row">
      <div class="col-12">
        <b-alert v-model="isValidationError" variant="danger" dismissible>{{validationError}}</b-alert>
      </div>
        </div>-->

        <div class="text-center" v-show="isReportLoading">
          <div>
            <b-spinner
              label="Spinning"
              variant="success"
              style="width: 10rem; height: 10rem"
            ></b-spinner>
          </div>
        </div>

        <div class="row" v-if="report.data != null">
          <div class="row" style="margin: 5px">
            <div style="margin: 20px; font-size: 13px; font-weight: bold">
              {{ reportTitle.label }}
              <br />
              {{
                this.$store.state.localization.data.mainPage.fuelTanks
                  .tableColumns.companyName
              }}: {{ reportTitle.companies.join(", ") }}
              <br />
              {{ this.$store.state.localization.data.common.beginPeriodLabel }}:
              {{ reportTitle.beginTime }}
              <br />
              {{ this.$store.state.localization.data.common.endPeriodLabel }}:
              {{ reportTitle.endTime }}
            </div>
          </div>
          <div class="col-12">
            <div
              v-html="tableContent"
              class="text-center b-table-sticky-header table-responsive"
              v-bind:style="{ 'max-height': reportTableHeight }"
            ></div>
          </div>
        </div>
      </pane>
    </splitpanes>

    <b-modal ref="create-report-modal" @ok="createReportModalOk">
      <template v-slot:modal-header="{}">
        <div></div>
      </template>
      <div>
        <b-form-textarea
          id="textarea"
          style="font-size: 12px"
          v-model="userReportName"
          :placeholder="$store.state.localization.data.mainPage.reports.newSettingPlaceholder"
          rows="3"
          max-rows="6"
        ></b-form-textarea>
      </div>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="light" style="font-size: 12px" @click="cancel()">{{
          $store.state.localization.data.common.table.cancel
        }}</b-button>
        <b-button variant="success" style="font-size: 12px" @click="ok()">{{
          $store.state.localization.data.common.table.ok
        }}</b-button>
      </template>
    </b-modal>
    <b-modal ref="update-report-modal" @ok="updateReportModalOk">
      <template v-slot:modal-header="{}">
        <div></div>
      </template>
      <div class="text-center" style="font-size: 12px">
        {{ this.$store.state.localization.data.mainPage.reports.changeSettingConfirm }}
      </div>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="light" style="font-size: 12px" @click="cancel()">{{
          $store.state.localization.data.common.table.cancel
        }}</b-button>
        <b-button variant="success" style="font-size: 12px" @click="ok()">{{
          $store.state.localization.data.common.table.ok
        }}</b-button>
      </template>
    </b-modal>
    <b-modal ref="delete-report-modal" @ok="deleteReportModalOk">
      <template v-slot:modal-header="{}">
        <div></div>
      </template>
      <div class="text-center" style="font-size: 12px">
        {{ this.$store.state.localization.data.mainPage.reports.deleteSettingConfirm }}
      </div>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="light" style="font-size: 12px" @click="cancel()">{{
          $store.state.localization.data.common.table.cancel
        }}</b-button>
        <b-button variant="success" style="font-size: 12px" @click="ok()">{{
          $store.state.localization.data.common.table.delete
        }}</b-button>
      </template>
    </b-modal>
    <b-modal ref="error-modal">
      <template v-slot:modal-header="{}">
        <div></div>
      </template>
      <div class="text-center" style="font-size: 12px">
        {{ this.serverError }}
      </div>
      <template v-slot:modal-footer="{ ok }">
        <b-button variant="success" style="font-size: 12px" @click="ok()">{{
          $store.state.localization.data.common.table.hide
        }}</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import vueMultiSelect from "vue-multi-select";
import "vue-multi-select/dist/lib/vue-multi-select.css";
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";

import { reportService, utilsService, roleService, filterService, userService } from "../../../services";

export default {
  name: "Reports",
  components: {
    Splitpanes,
    Pane,
    vueMultiSelect,
  },
  data() {
    return {
      isReportNameValid: null,
      isReportFilterKeysValid: null,
      isReportFilterValuesValid: null,
      isReportColumnsRightValid: null,
      REPORTS_EXPORT_ROLE: roleService.REPORTS_EXPORT_ROLE,
      REPORTS_GROUP_DAYS_ROLE: roleService.REPORTS_GROUP_DAYS_ROLE,
      tableContent: "",
      beginDate: null,
      beginTime: null,
      endDate: null,
      endTime: null,
      beginDateTime: null,
      endDateTime: null,
      reports: {},
      drivers: null,
      notificationTypes: null,
      serverError: null,
      report: {
        columnsLeft: {
          values: [],
          data: [],
        },
        columnsRight: {
          values: [],
          data: [],
        },
        filterKeys: {
          selected: null,
          options: [],
        },
        filterValues: {
          values: [],
          data: [],
          filters: [],
          options: {
            multi: true,
            labelName: "label",
          },
        },
        groups: {
          selected: null,
          options: [],
        },
        periodTypes: {
          selected: null,
          options: [],
        },
        headers: null,
        data: null,
        summary: null,
        title: null,
      },
      isValidationError: false,
      isReportLoading: false,
      validationError: null,
      reportNames: {},
      standardReportNames: {
        label: `${this.$store.state.localization.data.mainPage.reports.standardReportsLabel}:`,
        options: [],
      },
      userReportNames: {
        label: `${this.$store.state.localization.data.mainPage.reports.userReportsLabel}:`,
        options: [],
      },
      userReportName: null,
      selectedReportKey: "",
      isSelectedUserReport: false,
      isSelectedReport: false,
      reportTitle: {
        label: null,
        beginTime: null,
        endTime: null,
        companies: [],
      },
      fuelVolumePrecision: 0
    };
  },
  props: {
    fuelTanks: Array
  },
  computed: {
    splitPaneHeight() {
      const LEFT_TOP_POSITION_Y = 50;

      return `${document.documentElement.clientHeight - LEFT_TOP_POSITION_Y}px`;
    },
    reportTableHeight() {
      const REPORT_TABLE_POSITION_Y = 178;

      return `${
        document.documentElement.clientHeight - REPORT_TABLE_POSITION_Y
      }px`;
    },
    createReportActiveLabel() {
      if (
        !this.isSelectedReport ||
        this.isSelectedUserReport ||
        !this.report.periodTypes.selected ||
        !this.report.groups.selected ||
        !this.report.filterKeys.selected ||
        this.report.filterValues.values.length == 0 ||
        this.report.columnsRight.values == 0
      ) {
        return true;
      }

      return false;
    },
  },
  async created() {    
    const today = new Date();

    const todayString = new Date(
      today.getTime() - today.getTimezoneOffset() * 60000
    )
      .toISOString()
      .substr(0, 10);

    this.beginDate = todayString;
    this.beginTime = "00:00:00";

    this.endDate = todayString;
    this.endTime = "23:59:00";

    const localizedReports =
      this.$store.state.localization.data.mainPage.reports;

    const responseReports = await reportService.getReports();

    if (!responseReports.isSuccess) {
      return;
    }

    for (let i = 0; i < responseReports.data.standardReports.length; i++) {
      const key = `standard_${responseReports.data.standardReports[i].id}`;

      this.reports[key] = responseReports.data.standardReports[i];
      this.reports[key].type = "standard";

      this.standardReportNames.options.push({
        value: key,
        text: localizedReports[responseReports.data.standardReports[i].name]
          .label,
      });
    }

    for (let i = 0; i < responseReports.data.userReports.length; i++) {
      const key = `user_${responseReports.data.userReports[i].id}`;

      this.reports[key] = responseReports.data.userReports[i];
      this.reports[key].type = "user";

      this.userReportNames.options.push({
        value: key,
        text: this.reports[key].label,
      });
    }

    this.reportNames = {
      options: [this.standardReportNames, this.userReportNames],
    };

    this.drivers = responseReports.data.drivers;
    this.notificationTypes = responseReports.data.notificationTypes;
    this.impulseDevices = responseReports.data.impulseDevices;

    this.clearReport();

    this.report.filterValues.btnLabel = (values) =>
      `${this.$store.state.localization.data.mainPage.reports.selectedFilterValueLabel}: (${values.length})`;

    this.report.filterValues.filters = [
      {
        nameAll: this.$store.state.localization.data.common.setAllLabel,
        nameNotAll: this.$store.state.localization.data.common.resetAllLabel,
        func() {
          return true;
        },
      },
    ];

    for (const key of Object.keys(
      this.$store.state.localization.data.mainPage.reports.fuelReport
        .periodTypes
    )) {
      if (key == "days") {
        if (
          this.$store.state.authentication.roles.indexOf(
            this.REPORTS_GROUP_DAYS_ROLE
          ) != -1
        ) {
          this.report.periodTypes.options.push({
            value: key,
            text: this.$store.state.localization.data.mainPage.reports
              .fuelReport.periodTypes[key],
          });
        }
      } else {
        this.report.periodTypes.options.push({
          value: key,
          text: this.$store.state.localization.data.mainPage.reports.fuelReport
            .periodTypes[key],
        });
      }
    }

    this.report.periodTypes.selected = "range";

    for (const key of Object.keys(
      this.$store.state.localization.data.mainPage.reports.fuelReport.groups
    )) {
      this.report.groups.options.push({
        value: key,
        text: this.$store.state.localization.data.mainPage.reports.fuelReport
          .groups[key],
      });
    }

    this.report.groups.selected = "tank";

    this.$refs.columnsLeftRef.$el.ondblclick = () => {
      this.selectColumns();
    };

    this.$refs.columnsRightRef.$el.ondblclick = () => {
      this.deselectColumns();
    };

    const fuelVolumePrecisionSetting =
      this.$store.state.authentication.userSettings.find((x) => {
        return (
          x.settingName == userService.FUEL_VOLUME_PRECISION
        );
      });

    if (fuelVolumePrecisionSetting) {
      this.fuelVolumePrecision = parseInt(fuelVolumePrecisionSetting.settingValue );
    } else {
        this.fuelVolumePrecision = userService.FUEL_VOLUME_PRECISION_DEFAULT;
    }
  },
  mounted() {
    //the ugliest way for changing styles of vue-multi-select element

    const filtersElementDiv = document.querySelector(
      "#app > div > div > div:nth-child(2) > div > div:nth-child(1) > div:nth-child(8) > div > div"
    );

    filtersElementDiv.style.width = "200px";

    const filtersElementButton = document.querySelector(
      "#app > div > div > div:nth-child(2) > div > div:nth-child(1) > div:nth-child(8) > div > div > button"
    );

    filtersElementButton.style.width = "100%";
    filtersElementButton.style.fontSize = "12px";
    filtersElementButton.style.textAlign = "left";

    document.querySelector(
      "#app > div > div > div:nth-child(2) > div > div:nth-child(1) > div:nth-child(8) > div > div > div > div.checkBoxContainer"
    ).style["max-height"] = "200px";
  },
  methods: {
    selectReport(reportKey) {
      this.clearReport();

      const data = this.reports[reportKey];

      this.report.id = data.id;
      this.report.name = data.name;

      this.selectedReportKey = reportKey;
      this.isSelectedReport = true;

      const localizedReport =
        this.$store.state.localization.data.mainPage.reports[data.name];

      this.isSelectedUserReport = reportKey.indexOf("user") == 0;

      for (let i = 0; i < data.settings.length; i++) {
        const key = data.settings[i].name;

        if (data.settings[i].type == "column") {
          if (data.settings[i].isActive) {
            this.report.columnsRight.values.push({
              value: key,
              text: localizedReport.columns[key],
            });
          } else {
            this.report.columnsLeft.values.push({
              value: key,
              text: localizedReport.columns[key],
            });
          }
        } else if (data.settings[i].type == "periodType") {
          if (this.isSelectedUserReport) {
            if (data.settings[i].isActive) {
              this.report.periodTypes.selected = key;
            }
          }
        } else if (data.settings[i].type == "group") {
          if (this.isSelectedUserReport) {
            if (data.settings[i].isActive) {
              this.report.groups.selected = key;
            }
          }
        } else if (data.settings[i].type == "filter") {
          this.report.filterKeys.options.push({
            value: key,
            text: localizedReport.filters[key],
          });

          if (data.settings[i].isActive) {
            const filter = JSON.parse(data.settings[i].value);

            if (filter.type == "array") {
              filter.data.sort(function (a, b) {
                return a.value.toUpperCase() > b.value.toUpperCase() ? 1 : -1;
              });

              for (let j = 0; j < filter.data.length; j++) {
                this.report.filterValues.data.push({
                  key: filter.data[j].key,
                  label: filter.data[j].value,
                });

                if (filter.data[j].isActive) {
                  this.report.filterValues.values.push({
                    key: filter.data[j].key,
                    label: filter.data[j].value,
                  });
                }
              }
            }

            this.report.filterKeys.selected = key;
          }
        }
      }
    },
    clearReport() {
      this.report.columnsLeft.data = [];
      this.report.columnsLeft.values = [];

      this.report.columnsRight.data = [];
      this.report.columnsRight.values = [];

      this.report.filterKeys.options = [];
      this.report.filterKeys.selected = null;

      this.report.filterValues.data = [];
      this.report.filterValues.values = [];
    },
    selectReportFilter(event) {
      this.report.filterValues.data = [];
      this.report.filterValues.values = [];

      if (!event) {
        return;
      }

      if (event == filterService.TANK_IDS_FILTER) {
        this.report.filterValues.data = filterService.createFilterByFuelTanks(this.fuelTanks);
      } else if (event == filterService.COMPANY_ID_FILTER) {
        this.report.filterValues.data = filterService.createFilterByCompanies(this.fuelTanks);
      } else if (event == filterService.DEPO_FILTER) {
        this.report.filterValues.data = filterService.createFilterByDepos(this.fuelTanks);
      } else if (event == filterService.DRIVER_IDS_FILTER) {
        this.report.filterValues.data = filterService.createFilterByDrivers(this.drivers);
      } else if (event == filterService.DEVICE_ID_FILTER) {
        this.report.filterValues.data = filterService.createFilterByDevices(this.impulseDevices);
      }
      
      if (this.reports[this.selectedReportKey].type == "user") {
        const filter = this.reports[this.selectedReportKey].settings.find(
          (x) => x.type == "filter" && x.name == event
        );
  
        if (filter && filter.value) {
          this.report.filterValues.values = filterService.createFilterValues(filter.value);
        }
      }
    },
    createReport() {
      this.$refs["create-report-modal"].show();
    },
    selectColumns() {
      for (let i = 0; i < this.report.columnsLeft.data.length; i++) {
        const columnIndex = this.report.columnsLeft.values.findIndex(
          (x) => x.value == this.report.columnsLeft.data[i]
        );

        this.report.columnsRight.values.push(
          this.report.columnsLeft.values[columnIndex]
        );
        this.report.columnsLeft.values.splice(columnIndex, 1);
      }
    },
    selectAllColumns() {
      for (let i = 0; i < this.report.columnsLeft.values.length; i++) {
        this.report.columnsRight.values.push(this.report.columnsLeft.values[i]);
      }

      this.report.columnsLeft.data = [];
      this.report.columnsLeft.values = [];
    },
    deselectAllColumns() {
      for (let i = 0; i < this.report.columnsRight.values.length; i++) {
        this.report.columnsLeft.values.push(this.report.columnsRight.values[i]);
      }

      this.report.columnsRight.data = [];
      this.report.columnsRight.values = [];
    },
    deselectColumns() {
      for (let i = 0; i < this.report.columnsRight.data.length; i++) {
        const columnIndex = this.report.columnsRight.values.findIndex(
          (x) => x.value == this.report.columnsRight.data[i]
        );

        this.report.columnsLeft.values.push(
          this.report.columnsRight.values[columnIndex]
        );
        this.report.columnsRight.values.splice(columnIndex, 1);
      }
    },
    upColumns() {
      const newValues = [];

      for (let i = 0; i < this.report.columnsRight.values.length; i++) {
        const columnIndex = this.report.columnsRight.data.indexOf(
          this.report.columnsRight.values[i].value
        );

        if (columnIndex != -1 && i != 0) {
          const oldValue = newValues[i - 1];
          newValues[i - 1] = this.report.columnsRight.values[i];
          newValues[i] = oldValue;
        } else {
          newValues.push(this.report.columnsRight.values[i]);
        }
      }

      this.report.columnsRight.values = newValues;
    },
    downColumns() {
      const newValues = new Array(this.report.columnsRight.values.length);

      for (let i = this.report.columnsRight.values.length - 1; i >= 0; i--) {
        const columnIndex = this.report.columnsRight.data.indexOf(
          this.report.columnsRight.values[i].value
        );

        if (
          columnIndex != -1 &&
          i != this.report.columnsRight.values.length - 1
        ) {
          const oldValue = newValues[i + 1];
          newValues[i + 1] = this.report.columnsRight.values[i];
          newValues[i] = oldValue;
        } else {
          newValues[i] = this.report.columnsRight.values[i];
        }
      }

      this.report.columnsRight.values = newValues;
    },
    async createReportModalOk() {
      this.isReportLoading = true;

      const createdReport = await reportService.createReport(
        this.report,
        this.userReportName
      );

      if (!createdReport.isSuccess) {
        //TODO: added error handling
        return;
      }

      const key = `user_${createdReport.data.id}`;

      this.userReportNames.options.push({
        value: key,
        text: createdReport.data.label,
      });

      this.reports[key] = createdReport.data;
      this.isReportLoading = false;
    },
    async updateReport() {
      this.$refs["update-report-modal"].show();
    },
    async updateReportModalOk() {
      this.isReportLoading = true;

      const updatedReport = await reportService.updateReport(this.report);

      if (!updatedReport.isSuccess) {
        //TODO: added error handling
        return;
      }

      const key = `user_${updatedReport.data.id}`;

      this.reports[key] = updatedReport.data;

      this.isReportLoading = false;
    },
    deleteReport() {
      this.$refs["delete-report-modal"].show();
    },
    async deleteReportModalOk() {
      this.isReportLoading = true;

      const deletedReport = await reportService.deleteReport(this.report);

      if (!deletedReport.isSuccess) {
        //TODO: added error handling
        return;
      }

      const key = `user_${this.report.id}`;

      delete this.reports[key];

      const index = this.userReportNames.options.findIndex(
        (x) => x.value == key
      );
      this.userReportNames.options.splice(index, 1);

      this.selectedReportKey = "";
      this.clearReport();

      this.isSelectedReport = false;
      this.isReportLoading = false;
    },
    async getReport() {
      this.isValidationError = false;
      this.report.data = null;
      this.report.headers = [];
      this.isReportLoading = false;

      if (!this.reportNames.selected) {
        this.validationError =
          this.$store.state.localization.data.mainPage.reports.validations.reports;
          this.isValidationError = true;
          this.isReportNameValid = false;
          return;
      } else {
        this.isReportNameValid = null;
      }

      if (!this.report.periodTypes.selected) {
        this.validationError =
          this.$store.state.localization.data.mainPage.reports.validations.periodTypes;
        this.isValidationError = true;

        return;
      }

      if (!this.report.groups.selected) {
        this.validationError =
          this.$store.state.localization.data.mainPage.reports.validations.groups;
        this.isValidationError = true;

        return;
      }

      if (!this.report.filterKeys.selected) {
        this.isReportFilterKeysValid = false;
        return;
      } else { 
        this.isReportFilterKeysValid = null; 
      }

      if (this.report.filterValues.values.length == 0) {
        this.isReportFilterValuesValid = false;
        document.querySelector("#report_filter_keys button").style.borderColor = "#dc3545";
        return;
      } else { 
        this.isReportFilterValuesValid = null; 
        document.querySelector("#report_filter_keys button").style.borderColor = null;
      }
      
      if (this.report.columnsRight.values.length == 0) {
        this.validationError =
          this.$store.state.localization.data.mainPage.reports.validations.columns;
        this.isValidationError = true;
        this.isReportColumnsRightValid = false;
        return;
      } else {
        this.isReportColumnsRightValid = null;
      }

      this.beginDateTime = new Date(
        (this.beginDate + " " + this.beginTime).replace(/-/g, "/")
      );
      this.endDateTime = new Date(
        (this.endDate + " " + this.endTime).replace(/-/g, "/")
      );

      if (isNaN(this.beginDateTime)) {
        this.validationError =
          this.$store.state.localization.data.common.validations.beginPeriod;
        this.isValidationError = true;

        return;
      }

      if (isNaN(this.endDateTime)) {
        this.validationError =
          this.$store.state.localization.data.common.validations.endPeriod;
        this.isValidationError = true;

        return;
      }

      if (this.beginDateTime > this.endDateTime) {
        this.validationError =
          this.$store.state.localization.data.common.validations.endPeriodInvalid;
        this.isValidationError = true;

        return;
      }

      if (this.report.filterValues.values.length == 0) {
        this.validationError =
          this.$store.state.localization.data.mainPage.reports.validations.filters;
        this.isValidationError = true;

        return;
      }

      this.isReportLoading = true;

      const isAccountingSystem =
        this.$store.state.authentication.roles.indexOf(
          roleService.REPORTS_ACCOUNTING_SYSTEM_READ_ROLE
        ) != -1;

      let response;

      if (this.report.name == reportService.FUEL_REPORT_NAME) {
        response = await reportService.getFuelReport(
          this.beginDateTime,
          this.endDateTime,
          this.report,
          isAccountingSystem,
          this.fuelTanks
        );
      } else if (this.report.name == reportService.FUEL_CHARGES_REPORT_NAME) {
        response = await reportService.getFuelChargesReport(
          this.beginDateTime,
          this.endDateTime,
          this.report,
          this.fuelTanks
        );
      } else if (this.report.name == reportService.FUEL_INPUT_DOCUMENTS_REPORT_NAME) {
        response = await reportService.getFuelInputDocumentsReport(
          this.beginDateTime,
          this.endDateTime,
          this.report
        );
      } else if (this.report.name == reportService.NOTIFICATIONS_REPORT_NAME) {
        response = await reportService.getNotificationsReport(
          this.beginDateTime,
          this.endDateTime,
          this.report
        );
      } else if (this.report.name == reportService.FUEL_LIMITS_REPORT_NAME) {
        response = await reportService.getFuelLimitsReport(
          this.beginDateTime,
          this.endDateTime,
          this.report
        );
      } else if (this.report.name == reportService.DIGITAL_DEVICES_REPORT_NAME) {
        response = await reportService.getDigitalDevicesReport(
          this.beginDateTime,
          this.endDateTime,
          this.report
        );
      } else if (this.report.name == reportService.AZK_FUEL_OUTPUT_DOCUMENTS_REPORT_NAME) {
        response = await reportService.getAzkFuelOutputDocumentsReport(
          this.beginDateTime,
          this.endDateTime,
          this.report,
          this.fuelTanks
        );
      } else if (this.report.name == reportService.AZK_FUEL_CHANGE_DOCUMENTS_REPORT_NAME) {
        response = await reportService.getAzkFuelChangeDocumentsReport(
          this.beginDateTime,
          this.endDateTime,
          this.report,
          this.fuelTanks
        );
      } else if (this.report.name == reportService.AZK_FUEL_INPUT_DOCUMENTS_REPORT_NAME) {
        response = await reportService.getAzkFuelInputDocumentsReport(
          this.beginDateTime,
          this.endDateTime,
          this.report,
          this.fuelTanks
        );
      } else if (this.report.name == reportService.AZK_IMPULSE_DEVICE_REPORT_NAME) {
        response = await reportService.getAzkImpulseDeviceReport(
          this.beginDateTime,
          this.endDateTime,
          this.report
        );
      } else if (this.report.name == reportService.AZK_FUEL_REPORT_NAME) {
        response = await reportService.getAzkFuelReport(
          this.beginDateTime,
          this.endDateTime,
          this.report,
          this.fuelTanks
        );
      }

      if (response.isSuccess) {
        if (response.data.reports) {
          this.report.data = response.data;
          this.sortReportData();
  
          this.createReportTitle(response.data.reports);
  
          if (this.report.periodTypes.selected == "range") {
            this.createTableReportRange(response.data);
          } else {
            this.createTableReportDays(response.data);
          }
        } else {
            this.serverError = this.$store.state.localization.data.mainPage.reports.emptyDataError;
            this.$refs["error-modal"].show();
        }
      } else {
        if (response.data.error == "invalidParameter") {
          if (response.data.localizationParameters && response.data.localizationParameters.ParameterName == "BeginTime or EndTime") {
            this.serverError = this.$store.state.localization.data.mainPage.reports.maxTimePeriodError;
          } else if (response.data.localizationParameters && response.data.localizationParameters.ParameterName == "Filters.TankIds.Length") {
            this.serverError = this.$store.state.localization.data.mainPage.reports.maxCountItemsPeriodError;
          } else {
             this.serverError = this.$store.state.localization.data.mainPage.reports.getDataError;
          }
          this.$refs["error-modal"].show();
        }
      }

      this.isReportLoading = false;
    },
    sortReportData() {
      for (let i = 0; i < this.report.data.reports.length; i++) {
        this.report.data.reports[i].rows.sort(function (a, b) {
          if (a.fuelConsumption && b.fuelConsumption) {
            if (
              a.fuelConsumption.fuelConsumptionSensorId !=
              b.fuelConsumption.fuelConsumptionSensorId
            ) {
              return (
                a.fuelConsumption.fuelConsumptionSensorId >
                b.fuelConsumption.fuelConsumptionSensorId
              );
            } else {
              return a.fuelConsumption.fuelConsumptionSensorType >
                b.fuelConsumption.fuelConsumptionSensorType
                ? 1
                : -1;
            }
          }

          if (a.companyName && b.companyName) {
            const companyNameA = a.companyName.toUpperCase();
            const companyNameB = b.companyName.toUpperCase();

            if (companyNameA != companyNameB) {
              return companyNameA > companyNameB ? 1 : -1;
            }
          }

          if (a.depoName && b.depoName) {
            const depoNameA = a.depoName.toUpperCase();
            const depoNameB = b.depoName.toUpperCase();

            if (depoNameA != depoNameB) {
              return depoNameA > depoNameB ? 1 : -1;
            }
          }

          if (a.tankName && b.tankName) {
            const fuelTankNameA = a.tankName.toUpperCase();
            const fuelTankNameB = b.tankName.toUpperCase();

            if (fuelTankNameA != fuelTankNameB) {
              return fuelTankNameA > fuelTankNameB ? 1 : -1;
            }
          }

          if (a.chargeFuelTime && b.chargeFuelTime) {
            return a.chargeFuelTime > b.chargeFuelTime ? 1 : -1;
          }

          if (a.vehicleName && b.vehicleName) {
            const vehicleNameA = a.vehicleName.toUpperCase();
            const vehicleNameB = b.vehicleName.toUpperCase();

            if (vehicleNameA != vehicleNameB) {
              return vehicleNameA > vehicleNameB ? 1 : -1;
            }
          }

          if (a.startWork && b.startWork) {
            return a.startWork > b.startWork ? 1 : -1;
          }

          if (a.notificationTime && b.notificationTime) {
            return a.notificationTime > b.notificationTime ? 1 : -1;
          }

          if (a.inputTime && b.inputTime) {
            return a.inputTime > b.inputTime ? 1 : -1;
          }

            return Math.random() - 0.5;
        });
      }
    },
    async exportReport(format) {
      let name, downloadedName;

      const reportName = this.reports[this.selectedReportKey].name;

      if (this.reports[this.selectedReportKey].label) {
        downloadedName = this.reports[this.selectedReportKey].label;
        name = `${this.$store.state.localization.data.mainPage.reports.reportName}: ${this.reports[this.selectedReportKey].label}`;
      } else {
        downloadedName = this.$store.state.localization.data.mainPage.reports[reportName].label;
        name = `${this.$store.state.localization.data.mainPage.reports.reportName}: ${downloadedName}`;
      }

      const title = `${this.$store.state.localization.data.mainPage.fuelTanks.tableColumns.companyName}: ${this.report.title}`;

      const summary = {
        label: this.$store.state.localization.data.mainPage.reports.summary,
      };

      const headers = [];
      for (let i = 0; i < this.report.headers.length; i++) {
        // const headerWidth = this.getHeaderWidth(this.report.headers[i].key);

        if(this.$store.state.localization.data.mainPage.reports[reportName].columns[this.report.headers[i].key]) {
          headers.push({key: this.report.headers[i].key, label: this.$store.state.localization.data.mainPage.reports[reportName].columns[this.report.headers[i].key]})
        } else {
          headers.push({key: this.report.headers[i].key, label: this.report.headers[i].label})
        }
      }

      await reportService.exportReport(
        format,
        downloadedName,
        name,
        this.report.periodTypes.selected,
        title,
        this.beginDateTime,
        this.endDateTime,
        headers,
        this.report.data,
        summary,
        this.$store.state.localization.data.common.beginPeriodLabel,
        this.$store.state.localization.data.common.endPeriodLabel
      );
    },
    getHeaderWidth(key) {
      const DEFAULT_HEADER_WIDTH = 5000;

      if (key == "startVolume15" || key == "endVolume15" || key == "densityChangeFix" || key == "fuelConsumptionDifference" || key == "fuelWeightConsumptionDifference" || key == "fuelConsumption15Difference" ||
          key == "startDensity" || key =="endDensity" || key == "topLimitLevel" || key == "bottomLimitLevel" || key == "startLevel" || key == "endLevel" || key == "startVolumePercent" || key == "endVolumePercent"
      ) {
        return 5500;
      }

      return DEFAULT_HEADER_WIDTH;
    },
    selectedPeriodTimesToday() {
      const today = new Date();

      const beginDateString = new Date(
        today.getTime() - today.getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);

      this.beginDate = beginDateString;
      this.beginTime = "00:00:00";

      this.endDate = beginDateString;
      this.endTime = "23:59:00";
    },
    selectedPeriodTimesYesterday() {
      const today = new Date();

      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);

      const beginDateString = new Date(
        yesterday.getTime() - yesterday.getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);

      this.beginDate = beginDateString;
      this.beginTime = "00:00:00";

      this.endDate = beginDateString;
      this.endTime = "23:59:00";
    },
    selectedPeriodTimesLastWeek() {
      const today = new Date();

      const lastWeek = new Date(today);
      lastWeek.setDate(today.getDate() - 7);

      const beginDateString = new Date(
        lastWeek.getTime() - lastWeek.getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);
      const endDateString = new Date(
        today.getTime() - today.getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);

      this.beginDate = beginDateString;
      this.beginTime = "00:00:00";

      this.endDate = endDateString;
      this.endTime = "23:59:00";
    },
    selectedPeriodTimesLastMonth() {
      const today = new Date();

      const lastMonth = new Date(today);
      lastMonth.setDate(today.getDate() - 30);

      const beginDateString = new Date(
        lastMonth.getTime() - lastMonth.getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);
      const endDateString = new Date(
        today.getTime() - today.getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);

      this.beginDate = beginDateString;
      this.beginTime = "00:00:00";

      this.endDate = endDateString;
      this.endTime = "23:59:00";
    },
    createReportTitle(reports) {
      let selectedReport = this.standardReportNames.options.find(
        (item) => item.value == this.selectedReportKey
      );

      if (!selectedReport) {
        selectedReport = this.userReportNames.options.find(
          (item) => item.value == this.selectedReportKey
        );
      }

      this.reportTitle.label = selectedReport.text;
      this.reportTitle.beginTime = utilsService.formatDateTime(
        this.beginDateTime,
        utilsService.DATE_TIME_FORMAT
      );
      this.reportTitle.endTime = utilsService.formatDateTime(
        this.endDateTime,
        utilsService.DATE_TIME_FORMAT
      );

      this.reportTitle.companies = [];

      for (let i = 0; i < reports.length; i++) {
        if (this.reportTitle.companies.indexOf(reports[i].subject.title) == -1)
          this.reportTitle.companies.push(reports[i].subject.title);
      }
    },
    calculateFuelVolumeConsumptions(data) {
      const fuelConsumptions = [];

      for (let i = 0; i < data.length; i++) {
        const items = [];

        for (let j = 0; j < data[i].rows.length; j++) {
          const sensorType = data[i].rows[j].fuelConsumption
            ? data[i].rows[j].fuelConsumption.fuelConsumptionSensorType
            : data[i].rows[j].fuelConsumptionDifference
            ? data[i].rows[j].fuelConsumptionDifference
                .fuelConsumptionSensorType
            : "";

          if (sensorType == "group") {
            let vehicleId = data[i].rows[j].fuelConsumption
              ? data[i].rows[j].fuelConsumption.vehicleId
              : data[i].rows[j].fuelConsumptionDifference.vehicleId;

            let sensorId = data[i].rows[j].fuelConsumption
              ? data[i].rows[j].fuelConsumption.sensorId
              : data[i].rows[j].fuelConsumptionDifference.sensorId;

            let fuelConsumptionSensorId = data[i].rows[j].fuelConsumption
              ? data[i].rows[j].fuelConsumption.fuelConsumptionSensorId
              : data[i].rows[j].fuelConsumptionDifference
                  .fuelConsumptionSensorId;

            if (items.length == 0) {
              items.push({
                vehicleId: vehicleId,
                sensorId: sensorId,
                fuelConsumptionSensorId: fuelConsumptionSensorId,
                countRows: 1,
                isFuelConsumptionActive: true,
                isFuelConsumptionDifferenceActive: true,
              });
            } else {
              const item = items.find(
                (x) => x.fuelConsumptionSensorId == fuelConsumptionSensorId
              );

              if (!item) {
                items.push({
                  vehicleId: vehicleId,
                  sensorId: sensorId,
                  fuelConsumptionSensorId: fuelConsumptionSensorId,
                  countRows: 1,
                  isFuelConsumptionActive: true,
                  isFuelConsumptionDifferenceActive: true,
                });
              } else {
                item.countRows++;
              }
            }
          }
        }

        fuelConsumptions.push(items);
      }

      return fuelConsumptions;
    },
    calculateFuelVolume15Consumptions(data) {
      const fuelConsumptions15 = [];

      for (let i = 0; i < data.length; i++) {
        const items = [];

        for (let j = 0; j < data[i].rows.length; j++) {
          const sensorType = data[i].rows[j].fuelConsumption15
            ? data[i].rows[j].fuelConsumption15.fuelConsumptionSensorType
            : data[i].rows[j].fuelConsumption15Difference
            ? data[i].rows[j].fuelConsumption15Difference
                .fuelConsumptionSensorType
            : "";

          if (sensorType == "group") {
            let vehicleId = data[i].rows[j].fuelConsumption15
              ? data[i].rows[j].fuelConsumption15.vehicleId
              : data[i].rows[j].fuelConsumption15Difference.vehicleId;

            let sensorId = data[i].rows[j].fuelConsumption15
              ? data[i].rows[j].fuelConsumption15.sensorId
              : data[i].rows[j].fuelConsumption15Difference.sensorId;

            let fuelConsumptionSensorId = data[i].rows[j].fuelConsumption15
              ? data[i].rows[j].fuelConsumption15.fuelConsumptionSensorId
              : data[i].rows[j].fuelConsumption15Difference
                  .fuelConsumptionSensorId;

            if (items.length == 0) {
              items.push({
                vehicleId: vehicleId,
                sensorId: sensorId,
                fuelConsumptionSensorId: fuelConsumptionSensorId,
                countRows: 1,
                isFuelConsumption15Active: true,
                isFuelConsumption15DifferenceActive: true,
              });
            } else {
              const item = items.find(
                (x) => x.fuelConsumptionSensorId == fuelConsumptionSensorId
              );

              if (!item) {
                items.push({
                  vehicleId: vehicleId,
                  sensorId: sensorId,
                  fuelConsumptionSensorId: fuelConsumptionSensorId,
                  countRows: 1,
                  isFuelConsumption15Active: true,
                  isFuelConsumption15DifferenceActive: true,
                });
              } else {
                item.countRows++;
              }
            }
          }
        }

        fuelConsumptions15.push(items);
      }

      return fuelConsumptions15;
    },
    calculateFuelWeightConsumptions(data) {
      const fuelConsumptions = [];

      for (let i = 0; i < data.length; i++) {
        const items = [];

        for (let j = 0; j < data[i].rows.length; j++) {
          const sensorType = data[i].rows[j].fuelWeightConsumption
            ? data[i].rows[j].fuelWeightConsumption.fuelConsumptionSensorType
            : data[i].rows[j].fuelWeightConsumptionDifference
            ? data[i].rows[j].fuelWeightConsumptionDifference
                .fuelConsumptionSensorType
            : "";

          if (sensorType == "group") {
            let vehicleId = data[i].rows[j].fuelWeightConsumption
              ? data[i].rows[j].fuelWeightConsumption.vehicleId
              : data[i].rows[j].fuelWeightConsumptionDifference.vehicleId;

            let sensorId = data[i].rows[j].fuelWeightConsumption
              ? data[i].rows[j].fuelWeightConsumption.sensorId
              : data[i].rows[j].fuelWeightConsumptionDifference.sensorId;

            let fuelConsumptionSensorId = data[i].rows[j].fuelWeightConsumption
              ? data[i].rows[j].fuelWeightConsumption.fuelConsumptionSensorId
              : data[i].rows[j].fuelWeightConsumptionDifference
                  .fuelConsumptionSensorId;

            if (items.length == 0) {
              items.push({
                vehicleId: vehicleId,
                sensorId: sensorId,
                fuelConsumptionSensorId: fuelConsumptionSensorId,
                countRows: 1,
                isFuelConsumptionActive: true,
                isFuelConsumptionDifferenceActive: true,
              });
            } else {
              const item = items.find(
                (x) => x.fuelConsumptionSensorId == fuelConsumptionSensorId
              );

              if (!item) {
                items.push({
                  vehicleId: vehicleId,
                  sensorId: sensorId,
                  fuelConsumptionSensorId: fuelConsumptionSensorId,
                  countRows: 1,
                  isFuelConsumptionActive: true,
                  isFuelConsumptionDifferenceActive: true,
                });
              } else {
                item.countRows++;
              }
            }
          }
        }

        fuelConsumptions.push(items);
      }

      return fuelConsumptions;
    },
    createTableReportRange(data) {
      const rows = [];

      const fuelVolumeConsumptions = this.calculateFuelVolumeConsumptions(data.reports);
      const fuelVolume15Consumptions = this.calculateFuelVolume15Consumptions(data.reports);
      const fuelWeightConsumptions = this.calculateFuelWeightConsumptions(data.reports);

      for (let i = 0; i < data.reports.length; i++) {
        for (let j = 0; j < data.reports[i].rows.length; j++) {
          const row = this.createRowReportRange(
            data.reports[i].rows[j],
            fuelVolumeConsumptions,
            fuelWeightConsumptions,
            fuelVolume15Consumptions,
            i
          );

          rows.push(row.join(""));
        }

        this.report.title = data.reports[i].subject.title;
      }

      const totalRowSummary = this.createRowTotalSummaryReportRange(
        data.summary
      );

      rows.push(totalRowSummary.join(""));

      const rowHeader = this.createRowHeaderReportRange();

      const thead = `<thead role='rowgroup' class='thead-light'>${rowHeader.join(
        ""
      )}</thead>`;

      this.tableContent = `<table role='table' aria-busy='false' class='table b-table table-hover table-bordered table-sm'>${thead}<tbody>${rows.join(
        ""
      )}</tbody></table>`;
    },
    createRowHeaderReportRange() {
      const rowHeader = [];

      rowHeader.push("<tr role='row'>");

      for (let i = 0; i < this.report.columnsRight.values.length; i++) {
        const key = this.report.columnsRight.values[i].value;

        this.report.headers.push({
          key: key,
          label: this.report.columnsRight.values[i].text,
        });

        if (i == 0) {
          rowHeader.push(
            `<th role='columnheader' scope='col' aria-colindex='${
              rowHeader.length + 1
            }' class = 'table-b-table-default b-table-sticky-column' style='vertical-align: middle; min-width: 100px;'>${
              this.report.columnsRight.values[i].text
            }</th>`
          );
        } else {
          rowHeader.push(
            `<th role='columnheader' scope='col' aria-colindex='${
              rowHeader.length + 1
            }' style='vertical-align: middle; min-width: 100px;'>${
              this.report.columnsRight.values[i].text
            }</th>`
          );
        }
      }

      rowHeader.push("</tr>");

      return rowHeader;
    },
    createRowReportRange(data, fuelVolumeConsumptions, fuelWeightConsumptions, fuelVolume15Consumptions, reportIndex) {
      const row = [];

      row.push("<tr>");

      for (let i = 0; i < this.report.columnsRight.values.length; i++) {
        const key = this.report.columnsRight.values[i].value;

        if (i == 0) {
          row.push(
            `<td class='table-b-table-default b-table-sticky-column' style='text-align:center; vertical-align:middle;'>${utilsService.formatValue(
              key,
              data[key], 
              this.$store.state.localization,
              this.fuelVolumePrecision
            )}</td>`
          );
        } else {
          if (key == "fuelConsumption") {
            if (data[key].fuelConsumptionSensorType == "group") {
              const fuelConsumption = fuelVolumeConsumptions[reportIndex].find(
                (x) =>
                  x.fuelConsumptionSensorId == data[key].fuelConsumptionSensorId
              );

              if (fuelConsumption.isFuelConsumptionActive) {
                row.push(
                  `<td rowspan=${
                    fuelConsumption.countRows
                  } style='text-align:center; vertical-align:middle;'>${utilsService.formatValue(
                    key,
                    data[key].value,
                    this.$store.state.localization,
                    this.fuelVolumePrecision
                  )}</td>`
                );

                fuelConsumption.isFuelConsumptionActive = false;
              }
            } else {
              row.push(
                `<td style='text-align:center; vertical-align:middle;'>${utilsService.formatValue(
                  key,
                  data[key].value,
                  this.$store.state.localization,
                  this.fuelVolumePrecision
                )}</td>`
              );
            }
          } else if (key == "fuelConsumptionDifference") {
            if (data[key].fuelConsumptionSensorType == "group") {
              const fuelConsumption = fuelVolumeConsumptions[reportIndex].find(
                (x) =>
                  x.fuelConsumptionSensorId == data[key].fuelConsumptionSensorId
              );

              if (fuelConsumption.isFuelConsumptionDifferenceActive) {
                row.push(
                  `<td rowspan=${
                    fuelConsumption.countRows
                  } style='text-align:center; vertical-align:middle;'>${utilsService.formatValue(
                    key,
                    data[key].value,
                    this.$store.state.localization,
                    this.fuelVolumePrecision
                  )}</td>`
                );
                fuelConsumption.isFuelConsumptionDifferenceActive = false;
              }
            } else {
              row.push(
                `<td style='text-align:center; vertical-align:middle;'>${utilsService.formatValue(
                  key,
                  data[key].value,
                  this.$store.state.localization,
                  this.fuelVolumePrecision
                )}</td>`
              );
            }
          } else if (key == "fuelConsumption15") {
            if (data[key].fuelConsumptionSensorType == "group") {
              const fuelConsumption = fuelVolume15Consumptions[reportIndex].find(
                (x) =>
                  x.fuelConsumptionSensorId == data[key].fuelConsumptionSensorId
              );

              if (fuelConsumption.isFuelConsumption15Active) {
                row.push(
                  `<td rowspan=${
                    fuelConsumption.countRows
                  } style='text-align:center; vertical-align:middle;'>${utilsService.formatValue(
                    key,
                    data[key].value,
                    this.$store.state.localization,
                    this.fuelVolumePrecision
                  )}</td>`
                );

                fuelConsumption.isFuelConsumption15Active = false;
              }
            } else {
              row.push(
                `<td style='text-align:center; vertical-align:middle;'>${utilsService.formatValue(
                  key,
                  data[key].value,
                  this.$store.state.localization,
                  this.fuelVolumePrecision
                )}</td>`
              );
            }
          } else if (key == "fuelConsumption15Difference") {
            if (data[key].fuelConsumptionSensorType == "group") {
              const fuelConsumption = fuelVolume15Consumptions[reportIndex].find(
                (x) =>
                  x.fuelConsumptionSensorId == data[key].fuelConsumptionSensorId
              );

              if (fuelConsumption.isFuelConsumption15DifferenceActive) {
                row.push(
                  `<td rowspan=${
                    fuelConsumption.countRows
                  } style='text-align:center; vertical-align:middle;'>${utilsService.formatValue(
                    key,
                    data[key].value,
                    this.$store.state.localization,
                    this.fuelVolumePrecision
                  )}</td>`
                );
                fuelConsumption.isFuelConsumption15DifferenceActive = false;
              }
            } else {
              row.push(
                `<td style='text-align:center; vertical-align:middle;'>${utilsService.formatValue(
                  key,
                  data[key].value,
                  this.$store.state.localization,
                  this.fuelVolumePrecision
                )}</td>`
              );
            }
          } else if (key == "fuelWeightConsumption") {
            if (data[key].fuelConsumptionSensorType == "group") {
              const fuelConsumption = fuelWeightConsumptions[reportIndex].find(
                (x) =>
                  x.fuelConsumptionSensorId == data[key].fuelConsumptionSensorId
              );

              if (fuelConsumption.isFuelConsumptionActive) {
                row.push(
                  `<td rowspan=${
                    fuelConsumption.countRows
                  } style='text-align:center; vertical-align:middle;'>${utilsService.formatValue(
                    key,
                    data[key].value,
                    this.$store.state.localization,
                    this.fuelVolumePrecision
                  )}</td>`
                );

                fuelConsumption.isFuelConsumptionActive = false;
              }
            } else {
              row.push(
                `<td style='text-align:center; vertical-align:middle;'>${utilsService.formatValue(
                  key,
                  data[key].value,
                  this.$store.state.localization,
                  this.fuelVolumePrecision
                )}</td>`
              );
            }
          } else if (key == "fuelWeightConsumptionDifference") {
            if (data[key].fuelConsumptionSensorType == "group") {
              const fuelConsumption = fuelWeightConsumptions[reportIndex].find(
                (x) =>
                  x.fuelConsumptionSensorId == data[key].fuelConsumptionSensorId
              );

              if (fuelConsumption.isFuelConsumptionDifferenceActive) {
                row.push(
                  `<td rowspan=${
                    fuelConsumption.countRows
                  } style='text-align:center; vertical-align:middle;'>${utilsService.formatValue(
                    key,
                    data[key].value,
                    this.$store.state.localization,
                    this.fuelVolumePrecision
                  )}</td>`
                );
                fuelConsumption.isFuelConsumptionDifferenceActive = false;
              }
            } else {
              row.push(
                `<td style='text-align:center; vertical-align:middle;'>${utilsService.formatValue(
                  key,
                  data[key].value,
                  this.$store.state.localization,
                  this.fuelVolumePrecision
                )}</td>`
              );
            }
          } else {
            row.push(
              `<td style='text-align:center; vertical-align:middle;'>${utilsService.formatValue(
                key,
                data[key],
                this.$store.state.localization,
                this.fuelVolumePrecision
              )}</td>`
            );
          }
        }
      }

      row.push("</tr>");

      return row;
    },
    createRowTotalSummaryReportRange(summary) {
      const rowSummary = [];

      rowSummary.push(
        "<tr style='text-align:center; vertical-align:middle; font-weight: bold; color:#28a745;'>"
      );

      for (let i = 0; i < this.report.columnsRight.values.length; i++) {
        const key = this.report.columnsRight.values[i].value;

        if (summary[key]) {
          rowSummary.push(`<td>${utilsService.formatValue(key, summary[key], this.$store.state.localization, this.fuelVolumePrecision)}</td>`);
        } else {
          rowSummary.push("<td></td>");
        }
      }

      rowSummary.push("</tr>");

      this.report.summary = {};

      for (const key of Object.keys(summary)) {
        this.report.summary[key] = utilsService.formatNumber(summary[key], 1);
      }

      return rowSummary;
    },
    createTableReportDays(data) {
      const rows = [];

      const fuelVolumeConsumptions = this.calculateFuelVolumeConsumptions(data.reports);
      const fuelVolume15Consumptions = this.calculateFuelVolume15Consumptions(data.reports);
      const fuelWeightConsumptions = this.calculateFuelWeightConsumptions(data.reports);

      for (let i = 0; i < data.reports.length; i++) {
        for (let j = 0; j < data.reports[i].rows.length; j++) {
          const row = this.createRowReportDays(
            data.reports[i].rows[j],
            data.reports[i].subject,
            fuelVolumeConsumptions,
            fuelVolume15Consumptions,
            fuelWeightConsumptions,
            i
          );

          rows.push(row.join(""));

          this.report.title = data.reports[i].subject.title;
        }

        const rowIntermediateSummary =
          this.createRowIntermediateSummaryReportDays(data.reports[i].summary);

        rows.push(rowIntermediateSummary.join(""));
      }

      const totalRowSummary = this.createRowTotalSummaryReportDays(
        data.summary
      );

      rows.push(totalRowSummary.join(""));

      const rowHeader = this.createRowHeaderReportDays();

      const thead = `<thead role='rowgroup' class='thead-light'>${rowHeader.join(
        ""
      )}</thead>`;

      this.tableContent = `<table role='table' aria-busy='false' class='table b-table table-hover table-bordered table-sm' style='text-align:center; vertical-align:middle;'>${thead}<tbody>${rows.join(
        ""
      )}</tbody></table>`;
    },
    createRowHeaderReportDays() {
      const rowHeader = [];

      rowHeader.push("<tr role='row'>");

      this.report.headers.push({
        key: "date",
        label: this.$store.state.localization.data.common.date,
      });

      rowHeader.push(
        `<th role='columnheader' scope='col' aria-colindex='${
          rowHeader.length + 1
        }' class = 'table-b-table-default b-table-sticky-column' style='vertical-align: middle; min-width: 100px;'>${
          this.$store.state.localization.data.common.date
        }</th>`
      );

      for (let i = 0; i < this.report.columnsRight.values.length; i++) {
        const key = this.report.columnsRight.values[i].value;

        this.report.headers.push({
          key: key,
          label: this.report.columnsRight.values[i].text,
        });

        rowHeader.push(
          `<th role='columnheader' scope='col' aria-colindex='${
            rowHeader.length + 1
          }' style='vertical-align: middle; min-width: 100px;'>${
            this.report.columnsRight.values[i].text
          }</th>`
        );
      }

      rowHeader.push("</tr>");

      return rowHeader;
    },
    createRowReportDays(data, subject, fuelVolumeConsumptions, fuelVolume15Consumptions, fuelWeightConsumptions, reportIndex) {
      const row = [];

      row.push("<tr>");

      const year = subject.time.substr(0, 4);
      const month = subject.time.substr(4, 2);
      const day = subject.time.substr(6, 2);

      row.push(
        `<td class='table-b-table-default b-table-sticky-column'>${day}.${month}.${year}</td>`
      );

      for (let i = 0; i < this.report.columnsRight.values.length; i++) {
        const key = this.report.columnsRight.values[i].value;

        if (key == "fuelConsumption") {
          if (data[key].fuelConsumptionSensorType == "group") {
            const fuelConsumption = fuelVolumeConsumptions[reportIndex].find(
              (x) =>
                x.fuelConsumptionSensorId == data[key].fuelConsumptionSensorId
            );

            if (fuelConsumption.isFuelConsumptionActive) {
              row.push(
                `<td rowspan=${
                  fuelConsumption.countRows
                } style='text-align:center; vertical-align:middle;'>${utilsService.formatValue(
                  key,
                  data[key].value,
                  this.$store.state.localization,
                  this.fuelVolumePrecision
                )}</td>`
              );

              fuelConsumption.isFuelConsumptionActive = false;
            }
          } else {
            row.push(
              `<td style='text-align:center; vertical-align:middle;'>${utilsService.formatValue(
                key,
                data[key].value,
                this.$store.state.localization,
                this.fuelVolumePrecision
              )}</td>`
            );
          }
        } else if (key == "fuelConsumptionDifference") {
          if (data[key].fuelConsumptionSensorType == "group") {
            const fuelConsumption = fuelVolumeConsumptions[reportIndex].find(
              (x) =>
                x.fuelConsumptionSensorId == data[key].fuelConsumptionSensorId
            );

            if (fuelConsumption.isFuelConsumptionDifferenceActive) {
              row.push(
                `<td rowspan=${
                  fuelConsumption.countRows
                } style='text-align:center; vertical-align:middle;'>${utilsService.formatValue(
                  key,
                  data[key].value,
                  this.$store.state.localization,
                  this.fuelVolumePrecision
                )}</td>`
              );
              fuelConsumption.isFuelConsumptionDifferenceActive = false;
            }
          } else {
            row.push(
              `<td style='text-align:center; vertical-align:middle;'>${utilsService.formatValue(
                key,
                data[key].value,
                this.$store.state.localization,
                this.fuelVolumePrecision
              )}</td>`
            );
          }
        } else if (key == "fuelConsumption15") {
          if (data[key].fuelConsumptionSensorType == "group") {
            const fuelConsumption = fuelVolume15Consumptions[reportIndex].find(
              (x) =>
                x.fuelConsumptionSensorId == data[key].fuelConsumptionSensorId
            );

            if (fuelConsumption.isFuelConsumption15Active) {
              row.push(
                `<td rowspan=${
                  fuelConsumption.countRows
                } style='text-align:center; vertical-align:middle;'>${utilsService.formatValue(
                  key,
                  data[key].value,
                  this.$store.state.localization,
                  this.fuelVolumePrecision
                )}</td>`
              );

              fuelConsumption.isFuelConsumption15Active = false;
            }
          } else {
            row.push(
              `<td style='text-align:center; vertical-align:middle;'>${utilsService.formatValue(
                key,
                data[key].value,
                this.$store.state.localization,
                this.fuelVolumePrecision
              )}</td>`
            );
          }
        } else if (key == "fuelConsumption15Difference") {
          if (data[key].fuelConsumptionSensorType == "group") {
            const fuelConsumption = fuelVolume15Consumptions[reportIndex].find(
              (x) =>
                x.fuelConsumptionSensorId == data[key].fuelConsumptionSensorId
            );

            if (fuelConsumption.isFuelConsumption15DifferenceActive) {
              row.push(
                `<td rowspan=${
                  fuelConsumption.countRows
                } style='text-align:center; vertical-align:middle;'>${utilsService.formatValue(
                  key,
                  data[key].value,
                  this.$store.state.localization,
                  this.fuelVolumePrecision
                )}</td>`
              );
              fuelConsumption.isFuelConsumption15DifferenceActive = false;
            }
          } else {
            row.push(
              `<td style='text-align:center; vertical-align:middle;'>${utilsService.formatValue(
                key,
                data[key].value,
                this.$store.state.localization,
                this.fuelVolumePrecision
              )}</td>`
            );
          }
        } else if (key == "fuelWeightConsumption") {
          if (data[key].fuelConsumptionSensorType == "group") {
            const fuelConsumption = fuelWeightConsumptions[reportIndex].find(
              (x) =>
                x.fuelConsumptionSensorId == data[key].fuelConsumptionSensorId
            );

            if (fuelConsumption.isFuelConsumptionActive) {
              row.push(
                `<td rowspan=${
                  fuelConsumption.countRows
                } style='text-align:center; vertical-align:middle;'>${utilsService.formatValue(
                  key,
                  data[key].value,
                  this.$store.state.localization,
                  this.fuelVolumePrecision
                )}</td>`
              );

              fuelConsumption.isFuelConsumptionActive = false;
            }
          } else {
            row.push(
              `<td style='text-align:center; vertical-align:middle;'>${utilsService.formatValue(
                key,
                data[key].value,
                this.$store.state.localization,
                this.fuelVolumePrecision
              )}</td>`
            );
          }
        } else if (key == "fuelWeightConsumptionDifference") {
          if (data[key].fuelConsumptionSensorType == "group") {
            const fuelConsumption = fuelWeightConsumptions[reportIndex].find(
              (x) =>
                x.fuelConsumptionSensorId == data[key].fuelConsumptionSensorId
            );

            if (fuelConsumption.isFuelConsumptionDifferenceActive) {
              row.push(
                `<td rowspan=${
                  fuelConsumption.countRows
                } style='text-align:center; vertical-align:middle;'>${utilsService.formatValue(
                  key,
                  data[key].value,
                  this.$store.state.localization,
                  this.fuelVolumePrecision
                )}</td>`
              );
              fuelConsumption.isFuelConsumptionDifferenceActive = false;
            }
          } else {
            row.push(
              `<td style='text-align:center; vertical-align:middle;'>${utilsService.formatValue(
                key,
                data[key].value,
                this.$store.state.localization,
                this.fuelVolumePrecision
              )}</td>`
            );
          }
        } else {
          row.push(
            `<td style='text-align:center; vertical-align:middle;'>${utilsService.formatValue(
              key,
              data[key],
              this.$store.state.localization,
              this.fuelVolumePrecision
            )}</td>`
          );
        }
      }

      row.push("</tr>");

      return row;
    },
    createRowIntermediateSummaryReportDays(summary) {
      const rowSummary = [];

      rowSummary.push("<tr style='background-color:#fae5d3;'>");

      rowSummary.push(
        "<td class='table-b-table-default b-table-sticky-column'></td>"
      );

      for (let i = 0; i < this.report.columnsRight.values.length; i++) {
        const key = this.report.columnsRight.values[i].value;

        if (summary[key]) {
          rowSummary.push(`<td>${utilsService.formatValue(key, summary[key], this.$store.state.localization, this.fuelVolumePrecision)}</td>`);
        } else {
          rowSummary.push("<td></td>");
        }
      }

      rowSummary.push("</tr>");

      return rowSummary;
    },
    createRowTotalSummaryReportDays(summary) {
      const rowSummary = [];

      rowSummary.push("<tr style='font-weight: bold; color:#28a745;'>");

      rowSummary.push(
        "<td class='table-b-table-default b-table-sticky-column'></td>"
      );

      for (let i = 0; i < this.report.columnsRight.values.length; i++) {
        const key = this.report.columnsRight.values[i].value;

        if (summary[key]) {
          rowSummary.push(`<td>${utilsService.formatValue(key, summary[key], this.$store.state.localization, this.fuelVolumePrecision)}</td>`);
        } else {
          rowSummary.push("<td></td>");
        }
      }

      rowSummary.push("</tr>");

      this.report.summary = {};

      for (const key of Object.keys(summary)) {
        this.report.summary[key] = utilsService.formatNumber(summary[key], 1);
      }

      return rowSummary;
    },
  },
};
</script>
